import session from '@/shared/session'

const initialState = () => ({
	patient: {
		referrals: [],
	}
})

const state = initialState()

// getters
const getters = {
	getCurrentReferral: (state) => () => {
		return state.current
	},
	getPatientReferrals: (state) => () => {
		return state.patient.referrals
	}
}

// actions
const actions = {
	resetState ({ commit }) {
		commit('reset_state')
	},

	async getReferralsForCurrentPatient({ commit, state, rootState, dispatch }) {
		if (!rootState.patients.current) {
			return
		}

		dispatch("loading/load", "referrals", { root: true })

		const referrals  = await session
			.get(`/api/patients/${rootState.patients.current?.id}/referrals/`)

		commit("set_referrals", referrals.data)

		dispatch("loading/end", "referrals", { root: true })

		return state.patient.referrals
	},

	createReferral({ dispatch, commit, rootState }, data) {
		dispatch("loading/load", "referrals", { root: true })
		return session
				.post(`/api/referrals/`, {...data, decursus: rootState.decursus.current?.id})
				.then((referral) => {
					return referral.data
				})
	      .finally(() => {
	      	dispatch("getReferralsForCurrentPatient")
	        dispatch("loading/end", "referrals", { root: true })
	      })
	},

  deletePatientReferral({ commit, dispatch }, id) {
    dispatch("loading/load", "referrals", { root: true })
    return session
      .delete(`/api/referrals/${id}/`)
      .then(() => {
        return dispatch("getReferralsForCurrentPatient")
      })
      .finally(() => {
        dispatch("loading/end", "referrals", { root: true })
      })
  },

	createPatientAdminReferral({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "referrals", { root: true })
		return session
				.post(`/api/patients/administration/${rootState.patients.current?.id}/referrals/`, data)
				.then(() => {
					return dispatch("getReferralsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "referrals", { root: true })
	      })
	},
	
	processReferral({ commit, dispatch }, { id, date }) {
		dispatch("loading/load", "referrals", { root: true })
		return session
			.patch(`/api/referrals/${id}/process/`, { processed_date: date })
			.then(() => {
				return dispatch("getReferralsForCurrentPatient")
			})
      .finally(() => {
        dispatch("loading/end", "referrals", { root: true })
      })
	},

	updateDoctor({ commit, dispatch }, { id, doctor }) {
		dispatch("loading/load", "referrals", { root: true })
		return session
			.patch(`/api/referrals/${id}/update_doctor/`, { consulting_doctor: doctor })
			.then(() => {
				return dispatch("getReferralsForCurrentPatient")
			})
      .finally(() => {
        dispatch("loading/end", "referrals", { root: true })
      })
	},

	referralPrintableById({ commit, state }, id) {
		return session
				.get(`/api/referrals/${id}/printable/`)
				.then(printable => {
					return printable.data
				})
	},
	referralsTotalReport({ commit, state }) {
		return session
				.get(`/api/referrals/total_report/`)
				.then(results => {
					return results.data
				})
	},
	referralsYearReport({ commit, state }, year) {
		return session
				.get(`/api/referrals/year_report/${year}/`,)
				.then(results => {
					return results.data
				})
	},
	referralsYearTrendReport({ commit, state }, year) {
		return session
				.get(`/api/referrals/year_report/trend/${year}/`,)
				.then(results => {
					return results.data
				})
	},
	referralsMonthReport({ commit, state }, data) {
		return session
				.get(`/api/referrals/month_report/${data['month']}/${data['year']}/`,)
				.then(results => {
					return results.data
				})
	},
	referralsTypeMonthReport({ commit, state }, data) {
		let url = ""
		if (data['params']){
			url = `/api/referrals/month_report/types/${data['month']}/${data['year']}/?${data['params']}`

		} else {
			url = `/api/referrals/month_report/types/${data['month']}/${data['year']}/`

		}
		return session
				.get(url,)
				.then(results => {
					return results.data
				})
	},
	referralsTypeMonthTotalReport({ commit, state }, data) {
		return session
				.get(`/api/referrals/month_report/total/${data['month']}/${data['year']}/`,)
				.then(results => {
					return results.data
				})
	},
	referralsMonthTrendReport({ commit, state }, data) {
		return session
				.get(`/api/referrals/month_report/trend/${data['month']}/${data['year']}/`,)
				.then(results => {
					return results.data
				})
	},
}

// mutations
const mutations = {
  reset_state(state) {
		Object.assign(state, initialState())
  },
	
	set_referrals(state, referrals) {
		state.patient.referrals = referrals
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}